import { useContext } from "react"
import { graphsHooks } from ".."
import { GraphsContext } from "../GraphsContext"

const useDistributionTypeBtns = () => {
    const { types } = graphsHooks.constants

    const {
        accuracyStats, refetchAccuracyStats,
        factoredAccuracyStats, refetchFactoredAccuracyStats,
        fluencyStats, refetchFluencyStats,
        hesitationsStats, refetchHesitationsStats,
        accuracyRatingStats
    } = useContext(GraphsContext)

    const btns = [
        {
            key: types.factored_percent_accuracy,
            label: "דיוק (משוקלל)",
            action: () => { },
            percent: true,
            checkType: "percent_accuracy",
            stats: factoredAccuracyStats,
            refetch: refetchFactoredAccuracyStats,
            text: "אחוז התלמידים",
        },
        {
            key: types.percent_accuracy,
            label: "דיוק (גוֺלְמִי)",
            checkType: "percent_accuracy",
            action: () => { },
            percent: true,
            stats: accuracyStats,
            ratingStats: accuracyRatingStats,
            refetch: refetchAccuracyStats,
            text: "אחוז התלמידים",
        },
        {
            key: types.num_words_per_minute,
            label: "מספר מילים לדקה",
            checkType: "words_per_minute",
            action: () => { },
            stats: fluencyStats,
            refetch: refetchFluencyStats,
            text: "אחוז התלמידים",
        },
        {
            key: types.repetition_percent,
            label: "רצף הקריאה",
            checkType: "fluency",
            action: () => { },
            stats: hesitationsStats,
            refetch: refetchHesitationsStats,
            percent: true,
            fixed: 1,
            text: "אחוז התלמידים",
        }
        // {
        //     key: types.correct_words_per_minute,
        //     label: "מספר מילים נכונות לדקה",
        //     action: () => { }
        // },
        // {
        //     key: types.repetition_percent,
        //     label: " חזרות",
        //     action: () => { }
        // },
        // {
        //     key: types.self_correction_percent,
        //     label: " תיקונים עצמיים",
        //     action: () => { }
        // },
        // {
        //     key: types.self_correction_and_minor_error_percent,
        //     label: " תיקונים עצמיים עם שגיאה קלה",
        //     action: () => { }
        // }
    ]


    return btns
}

export default useDistributionTypeBtns